import React from 'react';
import { faFileLines } from '@fortawesome/pro-solid-svg-icons/faFileLines';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import IconMessageColumn from '../../../components/columns/icon-message-column';
import Global from '../../../store/global-selectors';

import { messages } from './messages';

/**
 * Component for displaying the pick list printed status of a fulfillment plan.
 * @param {string} fulfillmentPlanId
 * @returns {JSX.Element}
 */
const PickListPrintedColumn = ({ fulfillmentPlanId }) => {
  const pickListPrintedStatus = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'pickListPrintedStatus',
    }),
  );

  const { isPrinted, modifiedDateTime } = pickListPrintedStatus ?? {
    isPrinted: false,
    modifiedDateTime: null,
  };

  return (
    <IconMessageColumn
      date={modifiedDateTime}
      icon={faFileLines}
      message={<FormattedMessage {...messages.printed} />}
      state={isPrinted ? 'normal' : 'empty'}
      tooltipMessage={<FormattedMessage {...messages.pickListPrinted} />}
    />
  );
};

export const PickListPrinted = {
  getMessageDescriptor: () => messages.pickListPrinted,
  id: 'pick-list-printed',

  render: (data) => {
    return <PickListPrintedColumn fulfillmentPlanId={data.id} />;
  },
};
